export default __webpack_public_path__ + "static/media/english.569d2e38.png";